import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {WeatherIconComponent} from "./atoms/weather-icon/weather-icon.component";
import {WeatherInfoCardComponent} from "./components/weather-info-card/weather-info-card.component";
import {LabelStateComponent} from "./atoms/label-state/label-state.component";
import {IonicModule} from "@ionic/angular";
import {BackBtnComponent} from "./atoms/back-btn/back-btn.component";
import {AppDatePipe} from "./pipe/app-date.pipe";
import {TextBoxComponent} from "./atoms/text-box/text-box.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SelectComponent} from "./atoms/select/select.component";
import {TextAreaComponent} from "./atoms/text-area/text-area.component";
import {DrawerModalComponent} from "./components/drawer-modal/drawer-modal.component";
import {ChipComponent} from "./atoms/chip/chip.component";
import {OrderListPipe} from "./pipe/order-list.pipe";
import {RowInfoButtonComponent} from "./modules/row-info-button/row-info-button.component";
import {TitleSectionComponent} from "./modules/title-section/title-section.component";
import {NewsItemComponent} from "../news/news-item/news-item.component";
import {PharmacyCardComponent} from "../pharmacy/components/pharmacy-card/pharmacy-card.component";
import {PlaceItemComponent} from "./components/place-item/place-item.component";
import {BackgroundImageDirective} from "./directive/background-image-directive";
import {ClickStopPropagation} from "./directive/click-stop-propagation.directive";
import {ExperienceItemComponent} from "./components/experience-item/experience-item.component";
import {RouterModule} from "@angular/router";
import {TextValueComponent} from "./components/text-value/text-value.component";
import {ApplicationItemComponent} from "./components/application-item/application-item.component";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {IconCircleComponent} from "./components/icon-circle/icon-circle.component";
import {SafePipe} from "./pipe/safe.pipe";
import {TranslateModule} from "@ngx-translate/core";
import {TranslationPipe} from "./pipe/translation.pipe";
import {SearchBoxComponent} from "./atoms/search-box/search-box.component";
import {ImageSectionCardComponent} from "./components/image-section-card/image-section-card.component";
import {SectionTabComponent} from "./components/section-tab/section-tab.component";
import {TabComponent} from "./components/section-tab/tab/tab.component";
import {WasteSettingsComponent} from "./components/waste-settings/waste-settings.component";
import {DistancePlaceFooterComponent} from "./components/distance-place-footer/distance-place-footer.component";
import {DayAgoPipe} from "./pipe/day-ago.pipe";
import {JobAnnouncementItemComponent} from "./components/job-announcement-item/job-announcement-item.component";
import {ServiceBoxIconComponent} from "./components/service-box-icon/service-box-icon.component";
import {LottieComponent} from "ngx-lottie";
import {PrivacyContentComponent} from "./components/privacy-content/privacy-content.component";
import {TrackableItemsComponent} from "./components/trackable-items/trackable-items.component";
import {ViewMetricLabelComponent} from "./components/view-metric-label/view-metric-label.component";
import {RubricaItemComponent} from "./components/rubrica-item/rubrica-item.component";
import {ServiceBoxContainerComponent} from "./components/service-box-container/service-box-container.component";
import {TemplateContentComponent} from "./components/template-content/template-content.component";
import {EventsFilterModalComponent} from "../events/events-filter-modal/events-filter-modal.component";
import {
    WeatherCardSkeletonComponent
} from "./components/weather-info-card/weather-card-skeleton/weather-card-skeleton.component";
import {
  PharmacyCardSkeletonComponent
} from "../pharmacy/components/pharmacy-card/pharmacy-card-skeleton/pharmacy-card-skeleton.component";
import {NewItemSkeletonComponent} from "../news/news-item/new-item-skeleton/new-item-skeleton.component";
import {ModalHeaderComponent} from "./components/modal-header/modal-header.component";
import {AccordionListComponent} from "./components/accordion-list/accordion-list.component";
import {AccordionItemComponent} from "./components/accordion-list/accordion-item/accordion-item.component";
import {PharmacyActionsComponent} from "./components/pharmacy-actions/pharmacy-actions.component";
import {FavoriteBtnComponent} from "./components/favorite-btn/favorite-btn.component";
import {ContactBoxComponent} from "./components/contact-box/contact-box.component";
import {EventItemSklComponent} from "./components/event-item/event-item-skl/event-item-skl.component";
import {TruncatedTextModalComponent} from "./components/truncated-text-modal/truncated-text-modal.component";
import {BannerComponent} from "./components/banner/banner.component";
import {BannerSklComponent} from "./components/banner/banner-skl/banner-skl.component";

const exportComponents = [
  WeatherIconComponent,
  WeatherInfoCardComponent,
  LabelStateComponent,
  BackBtnComponent,
  AppDatePipe,
  TextBoxComponent,
  SelectComponent,
  TextAreaComponent,
  DrawerModalComponent,
  ChipComponent,
  OrderListPipe,
  RowInfoButtonComponent,
  TitleSectionComponent,
  NewItemSkeletonComponent,
  NewsItemComponent,
  PharmacyCardComponent,
  PlaceItemComponent,
  BackgroundImageDirective,
  ClickStopPropagation,
  ExperienceItemComponent,
  TextValueComponent,
  ApplicationItemComponent,
  IconCircleComponent,
  SafePipe,
  TranslationPipe,
  SearchBoxComponent,
  ImageSectionCardComponent,
  SectionTabComponent,
  TabComponent,
  WasteSettingsComponent,
  JobAnnouncementItemComponent,
  PrivacyContentComponent,
  TrackableItemsComponent,
  ViewMetricLabelComponent,
  RubricaItemComponent,
  ServiceBoxContainerComponent,
  TemplateContentComponent,
  EventsFilterModalComponent,
  AccordionItemComponent,
  AccordionListComponent,
  FavoriteBtnComponent,
  EventItemSklComponent,
  TruncatedTextModalComponent,
  PharmacyActionsComponent
];

@NgModule({
  declarations: [
    ...exportComponents
  ],
  exports: [...exportComponents,
    ReactiveFormsModule,
    RouterModule,
    IonicModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    LottieComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    DistancePlaceFooterComponent,
    DayAgoPipe,
    ServiceBoxIconComponent,
    LottieComponent,
    WeatherCardSkeletonComponent,
    PharmacyCardSkeletonComponent,
    ModalHeaderComponent
  ]
})
export class SharedModule { }
